/**
 * One mapping from the dubbing tab's voice picker to the wire.
 *
 * The cost card and the submit both have to describe the SAME job. They used to
 * build the payload separately: the submit sent every configured language while
 * the card sent one, so a five-language dub was quoted 698 tokens and charged
 * 3,490. Both now call this, so the languages and the TTS provider the quote is
 * computed from are literally the ones the dub will run with (RULE #-2).
 */

import type { AudioLanguageConfig } from '../common/LanguageSelector';

/** The provider the submit falls back to when a row has none selected. */
export const DEFAULT_DUBBING_TTS_PROVIDER = 'kokoro';

/** `VoiceConfig` as `shared/models/requests/audio_dubbing.py` declares it. */
export interface ApiVoiceConfig {
  language: string;
  provider: string;
  voice_id: string;
  speed: number;
}

/**
 * Convert the tab's per-language rows into the request's `voice_configs`.
 *
 * @param voiceConfigs - Rows from the language/voice picker.
 * @returns The `voice_configs` array both `POST /api/v1/dubbing` and
 *   `POST /api/v1/dubbing/audio-dubbing` accept, and that
 *   `POST /api/v1/cost/preview` prices the TTS provider from.
 */
export function toApiVoiceConfigs(voiceConfigs: AudioLanguageConfig[]): ApiVoiceConfig[] {
  return voiceConfigs.map((config) => ({
    language: config.language,
    provider: config.provider ?? DEFAULT_DUBBING_TTS_PROVIDER,
    voice_id: config.voice_id ?? '',
    speed: 1.0,
  }));
}
